export default __webpack_public_path__ + "static/media/TDSYNNEX-transparent.e12875de.svg";